<template>
  <v-dialog
    v-if="content"
    v-model="showDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :max-width="sn_snTwoFactorAuthDialogMixin_width"
    :transition="$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition'"
    :persistent="true"
  >
    <v-card id="two-factor-auth-dialog-content">
      <v-card-title
        v-if="state !== 'verify_phone'"
        class="headline mb-3"
        style="word-break: break-word;"
      >
        {{ content.two_factor_auth_needed_message }}
      </v-card-title>
      <v-card-text>
        <div
          v-if="state === 'verify_phone'"
          class="headline mb-3"
        >
          {{ content.verify_phone_title }}
        </div>
        <template v-if="state === 'chooseAuthMethod'">
          <p class="subheading subtitle">
            {{ content.select_method_of_authentication_message }}
          </p>
          <v-radio-group
            v-if="authMethods"
            v-model="chosenAuthMethod"
            :mandatory="true"
          >
            <v-radio
              v-for="authMethod in authMethods"
              :key="authMethod.value"
              :label="authMethod.value"
              :value="authMethod.auth_method"
              class="mb-2"
            />
          </v-radio-group>
          <v-row>
            <v-btn
              :loading="submitted"
              :disabled="chosenAuthMethod === null"
              class="primary ml-0"
              @click="sn_snTwoFactorAuthDialogMixin_sendCode"
            >
              {{ content.send_code_button }}
            </v-btn>
            <v-btn
              class="ml-1"
              text
              @click="sn_snTwoFactorAuthDialogMixin_cancelVerifyPhone"
            >
              {{ content.cancel_verify_phone_button }}
            </v-btn>
          </v-row>
        </template>
        <template v-else-if="state === 'verify2fa'">
          <p class="subheading">
            {{ content.enter_authentication_code_message }}
          </p>
          <v-text-field
            v-model="code"
            :maxlength="6"
            :error="error"
            :error-messages="errorMessages"
            :autofocus="true"
            name="code"
            label="Code"
            hint="Ex. 123456"
            @keyup.enter="sn_snTwoFactorAuthDialogMixin_validate2fa"
          />
          <v-btn
            :loading="submitted"
            :disabled="!code || code.length !== 6"
            class="primary ml-0"
            @click="sn_snTwoFactorAuthDialogMixin_validate2fa"
          >
            {{ content.verify_code_button }}
          </v-btn>
          <br>
          <a @click="state = 'chooseAuthMethod'">{{ content.get_a_new_code_button }}</a>
        </template>
        <template v-else-if="state === 'verify_phone'">
          <p class="subheading">
            {{ content.verify_phone_message }}
          </p>
          <PhoneInput
            v-model="phoneNumber"
            :error="error"
            :error-messages="errorMessages"
            color="primary"
            label="Verify phone number"
            name="(800) 555-1212"
            @focus="error=false;errorMessages=[];"
            @keyup.enter="sn_snTwoFactorAuthDialogMixin_verifyPhoneNumber()"
          />
          <v-btn
            :loading="submitted"
            :disabled="!phoneNumber || phoneNumber.length < 10"
            class="primary ml-0"
            @click="sn_snTwoFactorAuthDialogMixin_verifyPhoneNumber"
          >
            {{ content.verify_phone_button }}
          </v-btn>
          <a @click="sn_snTwoFactorAuthDialogMixin_cancelVerifyPhone">{{ content.cancel_verify_phone_button }}</a>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PhoneInput from '~/components/common/v2/inputs/snPhoneInput'
import snTwoFactorAuthDialogMixin from '../mixins/snTwoFactorAuthDialogMixin'

export default {
  name: 'MyTwoFactorAuthDialog',

  components: {
    PhoneInput
  },

  mixins: [snTwoFactorAuthDialogMixin],

  props: {
    eventData: {
      type: Object,
      default: () => {},
      required: false
    },

    value: {
      type: Boolean,
      default: false,
      required: true
    }
  }

}
</script>
